<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For my sole sisters.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?11a6b1d4